module.exports = __webpack_public_path__ + "img/cpjs5.bc648b8c.png";